import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import cancelFun from './modules/cancelFun'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        cancelFun
    },
    getters
})

export default store
